import script from "./TempA.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempA.vue?vue&type=script&lang=ts&setup=true"

import "./TempA.vue?vue&type=style&index=0&id=3a32d80e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a32d80e"]])

export default __exports__